// extracted by mini-css-extract-plugin
export default {"container":"Error404_container__U3GOR","text":"Error404_text__7tmiM","error":"Error404_error__qQtzR","volver":"Error404_volver__clPkr"};